import {
  ArtifactGroup,
  ArtifactType,
  IconKey,
  InteractiveSlide,
} from "../../models/client";

export function interactiveGroupToSlideItem(
  ig: ArtifactGroup
): InteractiveSlide {
  return {
    id: ig.id,
    heading: ig.name,
    tags: ig.tags,
    copy: ig.summary,
    innerSlides: ig.artifacts.map((object) => ({
      id: object.id,
      previewImg: object.previewImg,
      title: object.name,
      cursorIcon: cursorIcon(object.type),
      cursorText: object.helperText,
    })),
    // visualInnerSlides: ig.interactiveObjects.
  };
}

export function cursorIcon(type: ArtifactType): IconKey {
  let iconKey: IconKey = "add";
  switch (type) {
    case "bookArtifact":
      iconKey = "menuBook";
      break;
    case "threeSixtyArtifact":
      iconKey = "threeSixty";
      break;
    case "interactiveArtifact":
      iconKey = "reply";
      break;
    case "photoArtifact":
      iconKey = "add";
      break;
  }
  return iconKey;
}
